
/** 特殊処理文字・句読点 */
const KUTOUTEN = '、。．';

/** 特殊処理文字・捨て仮名 */
const HAN_ON   = 'ぁぃぅぇぉっゃゅょゎァィゥェォッャュョヮ';

/** 特殊処理文字・記号 */
const KAKKO    = '「」［］『』＜＞（）ー～－…―＝';


/**
 * キャンバスのテキスト描画utility
 */
export default class CanvasTextUtility {




  /**
   * 外部呼出し不可
   */
  private constructor() { }




  /**
   * キャンバスに縦書きします
   *
   * @param canvasContext
   * @param c 縦書き文字
   * @param x ｘ座標
   * @param y y座標
   */
  public static drawVertical(canvasContext: CanvasRenderingContext2D, c: string , x: number, y: number): void {

    const ts = canvasContext.measureText('あ').width;

    if (KUTOUTEN.indexOf(c) !== -1) {
      // 句読点は表示位置を補正
      canvasContext.fillText(c, x + ts / 2, y - ts / 2);
    } else if (HAN_ON.indexOf(c) !== -1) {
      // 半音は表示位置を補正
      canvasContext.fillText(c, x + ts / 8, y - ts / 8);
    } else if (KAKKO.indexOf(c) !== -1) {
      // カッコは表示位置を90度回転
      canvasContext.save();
      canvasContext.translate(x - ts * 7 / 8, y - ts * 7 / 8);
      canvasContext.rotate(90 * Math.PI / 180);
      canvasContext.fillText(c, 0, -ts);
      canvasContext.restore();
    } else {
      canvasContext.fillText(c, x, y);
    }

  }




}
